import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  appNavigationConstants,
  appNavigationConstants_Mobile,
} from "../../../utils/constants/header.constants";
import {
  MOBILE_ACCOUNTS_ROUTE,
  HOME_ROUTE,
  MOBILE_MENU_ROUTE,
  MY_PROFILE_ROUTE,
  EXCHANGE_SPORTS_ROUTE,
  CASINO_ROUTE,
  INT_CASINO_ROUTE,
  LOGIN_ROUTE,
  useAppSelector,
  setIsOneClickBettingEnabled,
  EXCHANGE_EVENT_TYPES,
  getInplayEvents,
  showToast,
  AppNavigationEnum,
} from "@hypexone/uicore";
import {
  useAppDispatch,
  setCompetition,
  setEventType,
  SPORTS_MAP,
} from "@hypexone/uicore";
import { isDesktop, isMobile } from "react-device-detect";
import React, { useState } from "react";
import HeaderSearchInput from "./HeaderSearchInput";
import { IoIosSettings } from "react-icons/io";
import { Radio, Settings } from "lucide-react";
import CheckboxComponent from "../shared/CheckboxComponent";
import CasinoIcon from "../../../assets/icons/header-icons/menu-casino.png";
import Modal from "../shared/ModalComponent";
import StakeSettings from "../user-menu-pages/StakeSettings";
interface SubHeaderProps {
  disableSportsSubheader?: boolean;
}
const SubHeader: React.FC<SubHeaderProps> = ({ disableSportsSubheader }) => {
  const pathName = useLocation().pathname;
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { langData } = useAppSelector((state) => state.cms);
  const { isOneClickBettingEnabled } = useAppSelector((state) => state.betSlip);

  const [isMobileSearchPopupOpen, setIsMobileSearchPopupOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [showSettings, setShowSettings] = useState(false);
  const { events: catalogEvents, selectedEventType } = useAppSelector(
    (state) => state.catalog,
  );
  const { allowedConfig } = useAppSelector((state) => state.common);
  const { loggedIn } = useAppSelector((state) => state.auth);
  const inplayEvents = getInplayEvents(catalogEvents, allowedConfig);

  const handleNavLinkClick = (title: string) => {
    dispatch(setCompetition({ id: "", name: "", slug: "" }));
    const sport = SPORTS_MAP.get(title);
    if (sport) {
      dispatch(setEventType(sport));
    }
  };

  const onNavClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    title: string,
    navigationUrl: string,
  ) => {
    if (navigationUrl?.startsWith("/dc/")) {
      if (!loggedIn) {
        e.preventDefault();
        navigate(LOGIN_ROUTE, { replace: true });
      }
      return;
    }
    handleNavLinkClick(title);
  };

  const [showStakeModal, setShowStakeModal] = useState<boolean>(false);

  const showSettingsTab =
    isDesktop &&
    /^\/exchange_sports\/[^/]+\/[^/]+\/[^/]+\/[^/]+$/.test(location.pathname);

  const excludedRoutes = [
    HOME_ROUTE,
    MOBILE_ACCOUNTS_ROUTE,
    MOBILE_MENU_ROUTE,
    MY_PROFILE_ROUTE,
    "/change-password",
    "/bonus_rewards",
  ];

  const excludeSubHeader =
    !excludedRoutes.includes(pathName) ||
    !pathName.startsWith(EXCHANGE_SPORTS_ROUTE);

  // Create a combined array of all sports with their event counts
  const allSportsWithCounts = EXCHANGE_EVENT_TYPES.map((sport) => {
    const inplayEvent = inplayEvents.find(
      (event) => event?.sportName?.toLowerCase() === sport?.name?.toLowerCase(),
    );
    return {
      ...sport,
      eventCount: inplayEvent ? inplayEvent.events.length : 0,
      sportName: sport.name,
    };
  });

  const getEventCountForTitle = (title: string): number => {
    const sportWithCount = allSportsWithCounts.find(
      (s) => s.sportName?.toLowerCase() === title?.toLowerCase(),
    );
    return sportWithCount?.eventCount ?? 0;
  };

  // Hidden scrollbar: let a vertical mouse wheel scroll the nav sideways
  const handleNavWheelScroll = (event: React.WheelEvent<HTMLDivElement>) => {
    if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
    event.currentTarget.scrollLeft += event.deltaY;
  };

  const sportsbookIndex = appNavigationConstants.findIndex(
    ({ title }) => title === AppNavigationEnum.SPORTS_BOOK,
  );
  const fixedDesktopNavItems = appNavigationConstants.slice(
    0,
    sportsbookIndex + 1,
  );
  const scrollableDesktopNavItems = appNavigationConstants.slice(
    sportsbookIndex + 1,
  );

  const renderDesktopNavItem = ({
    title,
    navigationUrl,
    langKey,
  }: (typeof appNavigationConstants)[number]) => {
    const eventCount = getEventCountForTitle(title);
    return (
      <NavLink
        to={navigationUrl}
        key={title}
        className={({ isActive }) =>
          `relative text-center text-xs text-nowrap px-3 py-[7px]
          border-r border-gray4 capitalize
          ${
            title === "Casino" || title === "Int Casino"
              ? "bg-header-gradient text-white"
              : title === "Sportsbook" ||
                  title === AppNavigationEnum.MULTI_MARKETS
                ? "bg-color text-white"
                : ""
          }
          ${title === "Multi Market" ? "bg-color" : ""}
          ${title === "PrediX" ? "animate-newItemHighlight motion-reduce:animate-none" : ""}
          ${
            isActive
              ? "bg-[#ffdc7a] shadow-[inset_0_0px_5px_0_rgba(83,33,33,.5)]"
              : ""
          }`
        }
        onClick={(e) => onNavClick(e, title, navigationUrl)}
      >
        <div className="flex items-center justify-center gap-1">
          {langData?.[langKey] ?? title}
          {eventCount > 0 && (
            <span className="inline-flex items-center rounded bg-white text-[10px] font-normal text-red-500 absolute top-[-10px] left-1/2 -translate-x-1/2 z-10">
              <div className="px-1">
                <Radio className="h-3 w-3 shrink-0 text-red-500" />
              </div>
              <div className="bg-red-500 text-white font-bold rounded-r px-1">
                {eventCount}
              </div>
            </span>
          )}
          {title === "Casino" && (
            <img
              src={CasinoIcon}
              alt="casino-icon"
              className="h-[18px] w-[18px]"
            />
          )}
          {/* {(title === "Binary" || title === "Sportsbook") && (
            <div className="absolute blink top-[-6px] right-[-16px] bg-red-500 text-white text-[8px] px-[2px] flex items-center justify-center">
              NEW
            </div>
          )} */}
        </div>
        {title === "PrediX" && (
          <div className="absolute top-[-6px] right-[1px] bg-red-500 text-white text-[8px] px-[2px] flex items-center justify-center blink rounded pointer-events-none">
            NEW
          </div>
        )}
      </NavLink>
    );
  };

  return (
    <div className="flex min-w-full font-bold text-[12px] relative">
      {isMobile &&
        excludeSubHeader &&
        (pathName == `${HOME_ROUTE}` ? true : disableSportsSubheader) && (
          <div className="flex bg-white justify-center w-full gap-[1px]">
            <div className="flex items-center w-full justify-center bg-black overflow-auto hide-scrollbar">
              <div className="flex">
                {appNavigationConstants_Mobile.map(
                  ({ title, navigationUrl }, index) => {
                    const eventCount = getEventCountForTitle(title);
                    return (
                      <NavLink
                        to={navigationUrl}
                        key={title}
                        className={({ isActive }) =>
                          `flex justify-center font-[400] items-center gap-1 px-[10px] py-[7px] text-white text-[14px] text-nowrap 
          ${
            index !== appNavigationConstants_Mobile.length - 1
              ? "border-r-[1px] border-gray4"
              : ""
          }
          ${
            isActive
              ? "bg-black1 border-x border-t border-white rounded-t-[8px]"
              : ""
          }`
                        }
                        onClick={(e) => onNavClick(e, title, navigationUrl)}
                      >
                        {title}
                        {eventCount > 0 && (
                          <span
                            className="inline-flex items-center gap-0.5 rounded py-[2px] pl-1 pr-1.5 text-[10px] font-normal text-white"
                            style={{
                              background:
                                "linear-gradient(-180deg, #F72424 0%, #BB1C00 100%)",
                            }}
                          >
                            <Radio className="h-3 w-3 shrink-0" />
                            {eventCount}
                          </span>
                        )}
                      </NavLink>
                    );
                  },
                )}
              </div>
            </div>
          </div>
        )}
      {isMobileSearchPopupOpen && (
        <div className="absolute bg-white p-2 top-0 w-full">
          <HeaderSearchInput
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            setIsMobileSearchPopupOpen={setIsMobileSearchPopupOpen}
          />
        </div>
      )}

      {isDesktop && (
        <div className="relative flex-1 min-w-0">
          {
            <div className="flex">
              {/* Home .. Sportsbook stay fixed; only the items after Sportsbook scroll */}
              <div className="flex flex-shrink-0">
                {fixedDesktopNavItems.map(renderDesktopNavItem)}
              </div>
              <div
                // pt/-mt give the live-count badges (top-[-10px]) room above the items,
                // since a scroll container clips anything outside its box
                className="flex flex-1 min-w-0 overflow-x-auto overflow-y-hidden hide-scrollbar pt-[10px] -mt-[10px] pointer-events-none [&>*]:pointer-events-auto"
                onWheel={handleNavWheelScroll}
              >
                {scrollableDesktopNavItems.map(renderDesktopNavItem)}
              </div>
            </div>
          }
        </div>
      )}

      {/* On desktop this sits beside the nav (not over it) so every nav item can scroll fully into view */}
      <div
        className={`${
          isDesktop ? "flex-shrink-0" : "absolute right-0 h-full"
        } flex items-center gap-2 bg-sub-header-gradient`}
      >
        <div className="text-xs flex flex-col items-center leading-tight px-2">
          <span className="font-normal text-gray-700">Time Zone:</span>
          <span className="font-semibold text-black">
            {(() => {
              try {
                const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const formatter = new Intl.DateTimeFormat("en-US", {
                  timeZone: tz,
                  timeZoneName: "short",
                });
                const parts = formatter.formatToParts(new Date());
                const tzName =
                  parts.find((p) => p.type === "timeZoneName")?.value ?? tz;
                return tzName;
              } catch {
                return "—";
              }
            })()}
          </span>
        </div>
        <div className="bg-header-gradient h-full flex items-center justify-center text-[#ffb600]">
          <div className="relative">
            <div className="h-1 w-full bg-[#ffb600] absolute top-[-11px]"></div>
            <div className="px-4">
              <CheckboxComponent
                checked={isOneClickBettingEnabled}
                onChange={() => {
                  if (loggedIn) {
                    dispatch(
                      setIsOneClickBettingEnabled(!isOneClickBettingEnabled),
                    );
                  } else {
                    dispatch(
                      showToast({
                        type: "error",
                        message: "Please login to enable one click betting",
                      }),
                    );
                  }
                }}
                label={"One Click Bet"}
                className={`w-4 h-4 rounded-md font-medium ${
                  isOneClickBettingEnabled
                    ? "opacity-100 accent-[#ffb600]"
                    : "opacity-30"
                }`}
              />
            </div>
          </div>
        </div>
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={() =>
            loggedIn
              ? setShowStakeModal(true)
              : dispatch(
                  showToast({
                    type: "error",
                    message: "Please login to edit stake",
                  }),
                )
          }
        >
          Setting <Settings className="w-4 h-4" />
        </div>
      </div>
      {showStakeModal && (
        <Modal
          isOpen={showStakeModal}
          onClose={() => setShowStakeModal(false)}
          title={langData?.["edit_stake"] ?? "Edit Stake"}
          isContentWidth
        >
          <StakeSettings />
        </Modal>
      )}
    </div>
  );
};

export default SubHeader;
